import { getWithPrefix, postWithPrefix } from '@/utils/request';

export async function list(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/list', queryParam);
}

export async function find(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/find', queryParam);
}

export async function add(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/notice/add', formData);
}

export async function update(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/notice/update', formData);
}

export async function del(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/notice/del', formData);
}

export async function publish(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/notice/publish', formData);
}

export async function srctypes(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/srctypes', queryParam);
}

export async function roleNames(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/roleNames', queryParam);
}

export async function msgtemps(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/msgtemps', queryParam);
}

export async function calcSendCount(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/staffcount', queryParam);
}

export async function clientLevels(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/notice/clientlevels', queryParam);
}

// 短信模板

export async function msgtempkeys(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/msgtempkeys/find', queryParam);
}

export async function msgtemplist(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/msgtemp/list', queryParam);
}

export async function msgtempfind(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/msgtemp/find', queryParam);
}

export async function msgtemptypes(params = {}) {
  const queryParam = { queryParam: JSON.stringify(params) };
  return getWithPrefix('/msgtemp/types', queryParam);
}

export async function msgtempadd(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/msgtemp/add', formData);
}

export async function msgtempupdate(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/msgtemp/update', formData);
}

export async function msgtempdelete(params = {}) {
  const updateParam = JSON.stringify(params);
  const formData = new FormData();
  formData.append('updateParam', updateParam);
  return postWithPrefix('/msgtemp/del', formData);
}
